import React from "react";

const Loader = ({ size }) => {
  if (size === "small") {
    return (
      <div className="flex items-center justify-center space-x-2">
        <div className="spinner-border animate-spin border-l-dark-blue border-r-dark-blue inline-block h-4 w-4 border-2 rounded-full" role="status">
          <span className="hidden">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center space-x-2 m-20">
      <div className="spinner-border animate-spin border-l-secondary/50 border-r-secondary/50 inline-block w-16 h-16 border-[6px] border-gray/10 rounded-full" role="status">
        <span className="hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
